import React, { useState, ChangeEvent } from "react";

interface FileInputHolderProps {
    input: {
        label: string;
        name: string;
    };
    onUpdate: (name: string, value: File | null) => void;
    setResumeFile: any;
}

export default function FileInputHolder({
    input,
    onUpdate,
    setResumeFile,
}: FileInputHolderProps) {
    const [hasInput, setHasInput] = useState(false);
    const [fileName, setFileName] = useState("No file chosen");
    const fileInputId = `${input.name}-file-input`;

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setHasInput(file !== null);
        onUpdate(event.target.name, file);
        if (file) {
            setResumeFile(file);
            setFileName(file.name);
        }
    };

    return (
        <div className="">
            <label htmlFor={fileInputId} className="text-white md:pl-4">
                {input.label}
            </label>
            <div className="flex items-center mt-4">
                <input
                    className="hidden file-input w-fit appearance-none px-0 md:px-4 border-0 text-cyan cursor-pointer hover:file:bg-white file:bg-transparent hover:file:text-purple file:duration-300 duration-300  file:text-white file:rounded-3xl file:border-solid file:border-2 file:border-white file:p-2 file:px-4 file:mr-8 file:cursor-pointer file:transition-transform hover:file:scale-105"
                    type="file"
                    name={input.name}
                    id={fileInputId}
                    onChange={handleInputChange}
                />
                <label
                    htmlFor={fileInputId}
                    className="mr-4 md:mx-4 min-w-fit text-white rounded-3xl border-solid border-2 border-white p-2 px-4 cursor-pointer text-nowrap transition-all duration-200 hover:scale-105 hover:text-purple hover:bg-white"
                >
                    Choose File
                </label>
                <span
                    id="fileChosen"
                    className="ml-2 text-cyan overflow-hidden"
                >
                    {fileName}
                </span>
            </div>
        </div>
    );
}
